import { OffsetDatesOptions } from "src/stores/wizard/config";

const dayInMillisecond = 60 * 60 * 24 * 1000;

const getFirstOfTodayDateInMillis = (): number => {
  const nowDate = new Date();
  nowDate.setHours(0, 0, 0, 0);

  return nowDate.getTime();
};

const getDiffDaysBetweenEpochDates = (date: number, anotherDate: number): number => {
  return Math.floor((date - anotherDate) / dayInMillisecond);
};

export const getOffsetDatesByDatesOption = (offsetOptions: OffsetDatesOptions): OffsetDatesOptions => {
  const offsetOptionsResult = {} as OffsetDatesOptions;
  const todayDateMillis = getFirstOfTodayDateInMillis();

  const startDateDays: number = offsetOptions.startDate
    ? getDiffDaysBetweenEpochDates(Date.parse(offsetOptions.startDate), todayDateMillis)
    : -1;
  const endDateDays: number = offsetOptions.endDate
    ? getDiffDaysBetweenEpochDates(Date.parse(offsetOptions.endDate), todayDateMillis)
    : -1;

  if (startDateDays >= 0 && endDateDays > 0 && startDateDays < endDateDays) {
    offsetOptionsResult.startDateOffset = startDateDays;
    offsetOptionsResult.endDateOffset = endDateDays;
    return offsetOptionsResult;
  }

  if (
    offsetOptions.startDateOffset &&
    offsetOptions.endDateOffset &&
    offsetOptions.startDateOffset > 0 &&
    offsetOptions.startDateOffset < offsetOptions.endDateOffset
  ) {
    offsetOptionsResult.startDateOffset = offsetOptions.startDateOffset;
    offsetOptionsResult.endDateOffset = offsetOptions.endDateOffset;
  }

  return offsetOptionsResult;
};
